import { render, staticRenderFns } from "./BoxPhotoStatus.vue?vue&type=template&id=2c42c2ed&scoped=true"
import script from "./BoxPhotoStatus.vue?vue&type=script&lang=js"
export * from "./BoxPhotoStatus.vue?vue&type=script&lang=js"
import style0 from "./BoxPhotoStatus.vue?vue&type=style&index=0&id=2c42c2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42c2ed",
  null
  
)

export default component.exports